import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Typography, Box } from "@material-ui/core";
import LogoPNG from "../../../Images/logo.png";
import { ReactComponent as LogoSVG} from "../../../Images/logo.svg";
import {useSelector} from "react-redux";
import {RootState} from "../../../redux/store";

const useStyle = makeStyles((theme: Theme) =>({
    root: {
        color: "rgb(0%, 0%, 0%)",
        display: "flex",
        alignItems: "center",
        maxWidth: "230px",
        justifyContent: "space-between",
        [theme.breakpoints.down("sm")]: {
            display: "none"
        },
    },
    logo: {
        fontFamily: "Merriweather",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "22px",
        lineHeight: "28px"
    },
    logIcon: {
        maxHeight: 40,
        cursor: "pointer"
    },
    logIconA: {
        display: "flex",
        maxWidth: "65px",
    }

}));

const Logo = () => {
    const classes = useStyle();
    const branding = useSelector((state: RootState) => state?.branding);
    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    return (
        <Box className={classes.root}>
            <a className={classes.logIconA} target="_blank" href={isWhiteLabel? branding.redirectUrl: process.env.REACT_APP_APP_URL}>
                { isWhiteLabel?
                    <img
                        src={branding.logo}
                        className={classes.logIcon}
                    />:
                    <LogoSVG/>
                }
            </a>
        </Box>
    );
};

export default Logo;
